<template>
  <v-chip
    @click="$emit('onSelectedTopicChip', $event, value)"
    :input-value="actionCompleted"
    class="mobileTopicChip"
    :color="(actionCompleted ? 'default' : 'default' )"
    :class="{ completed: actionCompleted }"
  >
    <span> {{ itemTitle }} </span>
    <v-icon right v-if="actionCompleted" color="success"> {{ tickIcon }} </v-icon>
  </v-chip>
</template>
  
<script>
  export default {
    name: 'TopicCloudItem',
    props: {
      itemId: {
        type: [String, Number]
      },
      value: {
        type: [String, Number]
      },
      itemTitle: {
        type: String
      },
      actionCompleted: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      tickIcon(){
        // return 'mdi-check';
        return 'mdi-checkbox-marked-circle-outline';
      }
    }
  };
</script>

<style scoped>
  .mobileTopicChip {
    margin: 0 0 1rem 0.5rem;
  }
  .mobileTopicChip:not(.completed) span {
    margin: 0 0.5rem 0 0.5rem; 
  }
  .mobileTopicChip.completed span {
    margin: 0 0 0 0.5rem; 
  }

</style>